"use strict";

var _regeneratorRuntime = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _toConsumableArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _error = require("../error");

var permission = function permission() {
  return function (_ref) {
    var userService = _ref.userService,
        persistenceService = _ref.persistenceService;
    var storage = persistenceService.namespace('permission').curry('superusers');
    var rootUsersP = userService.find({
      root: true
    }).then(function (users) {
      return users.map(function (_ref2) {
        var id = _ref2.id;
        return id;
      });
    });
    var storedSuperusersP = storage.get();
    var superusersP = Promise.all([rootUsersP, storedSuperusersP]).then(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          _ref4$ = _ref4[0],
          rootUsers = _ref4$ === void 0 ? [] : _ref4$,
          _ref4$2 = _ref4[1],
          storedSuperusers = _ref4$2 === void 0 ? [] : _ref4$2;

      return new Set([].concat(_toConsumableArray(rootUsers), _toConsumableArray(storedSuperusers)));
    });
    return {
      promote: function promote(userId) {
        var _this = this;

        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.abrupt("return", _this.guard( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                    var superusers;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return superusersP;

                          case 2:
                            superusers = _context.sent;
                            superusers.add(userId);
                            storage.set(Array.from(superusers));

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }))));

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))();
      },
      demote: function demote(userId) {
        var _this2 = this;

        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  return _context4.abrupt("return", _this2.guard( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                    var superusers, rootUsers, didDelete;
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return superusersP;

                          case 2:
                            superusers = _context3.sent;
                            _context3.next = 5;
                            return rootUsersP;

                          case 5:
                            rootUsers = _context3.sent;

                            if (!rootUsers.includes(userId)) {
                              _context3.next = 8;
                              break;
                            }

                            throw new _error.PermissionError('Root user cannot be demoted');

                          case 8:
                            didDelete = superusers.delete(userId);
                            _context3.next = 11;
                            return storage.set(Array.from(superusers));

                          case 11:
                            return _context3.abrupt("return", didDelete);

                          case 12:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }))));

                case 1:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }))();
      },
      isSuperuser: function isSuperuser(userId) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
          var superusers;
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return superusersP;

                case 2:
                  superusers = _context5.sent;
                  return _context5.abrupt("return", superusers.has(userId));

                case 4:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }))();
      },
      guard: function guard(block) {
        var _this3 = this;

        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
          var _yield$userService$ge, userId;

          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.next = 2;
                  return userService.getCurrentUser();

                case 2:
                  _yield$userService$ge = _context6.sent;
                  userId = _yield$userService$ge.id;
                  _context6.next = 6;
                  return _this3.isSuperuser(userId);

                case 6:
                  if (!_context6.sent) {
                    _context6.next = 12;
                    break;
                  }

                  _context6.next = 9;
                  return block();

                case 9:
                  return _context6.abrupt("return", _context6.sent);

                case 12:
                  throw new _error.PermissionError("User with ID ".concat(userId, " is not a superuser"));

                case 13:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }))();
      }
    };
  };
};

var _default = permission;
exports.default = _default;